module.exports = __webpack_public_path__ + "static/media/LK.a092f9d4.png";